import type { BoxProps } from "@qws-org/ui-kit";
import { Box } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { Action, MainBanner, Pages } from "~/core";
import { useDirectus } from "~/shared/utils/directus/useDirectus";

import { Column } from "./components/Column";
import { Row } from "./components/Row";

export type ImageParams = {
  format?:
    | "jpg"
    | "jpeg"
    | "png"
    | "gif"
    | "webp"
    | "avif"
    | "svg"
    | "bmp"
    | "ico"
    | "tiff";
  height?: number;
  width?: number;
};
export type MainBannerV2Props = {
  data: MainBanner;
  getUrl: (page: Pages) => string;
  onCallAction: (action: Action) => void;
  getImageUrl: (imageId: string, params?: ImageParams) => string;
  isControlInactive: (control: Action) => boolean;
} & BoxProps;
export type BannerVariant = "row" | "column";

const getBannerVariant = (data: MainBanner): BannerVariant => {
  return data.variant === "row" ? "row" : "column";
};

export const MainBannerV2: FC<MainBannerV2Props> = (props) => {
  const { data, ...rest } = props;
  const { getDirectusImage } = useDirectus();
  const bannerVariant = getBannerVariant(data);

  return (
    <Box
      bg={
        data.backgroundImage
          ? getDirectusImage(data.backgroundImage.id)
          : (data.backgroundColor ?? "")
      }
      {...rest}
      md={{
        bg: data.backgroundImage
          ? getDirectusImage(data.backgroundImage.id)
          : (data.backgroundColor ?? ""),
        ...rest.md,
      }}
      d={{
        bg: data.backgroundImage
          ? getDirectusImage(data.backgroundImage.id)
          : (data.backgroundColor ?? ""),
        ...rest.d,
      }}
      data-testid="main-banner"
    >
      {bannerVariant === "column" ? <Column {...props} /> : <Row {...props} />}
    </Box>
  );
};
